export { default, getServerSideProps } from './CouponsLanding';
